import { IActivityHistoryGroup, IActivityHistoryItem } from "../domain/model";

/**
 * Materializes the injected `component` (via each item's `componentFactory`)
 * on every item of the given groups, returning a fresh array of groups/items
 * without mutating the input.
 *
 * Both the main timeline and the importer view use this pattern: plugins
 * register a `componentFactory` on each item and the consumer expects
 * `item.component` to be a Lit template / HTMLElement ready to render.
 */
export const prepareGroupComponents = async (
  groups: IActivityHistoryGroup[],
): Promise<IActivityHistoryGroup[]> => {
  const prepareItems = (items: IActivityHistoryItem[]) =>
    Promise.all(
      items.map(async (item) => ({
        ...item,
        component: item.componentFactory ? await item.componentFactory({ item }) : undefined,
      })),
    );

  return Promise.all(
    groups.map(async (group) => ({
      ...group,
      items: (await prepareItems(group.items || [])) as IActivityHistoryItem[],
      subGroups: await Promise.all(
        (group.subGroups || []).map(async (sub) => ({
          ...sub,
          items: (await prepareItems(sub.items)) as IActivityHistoryItem[],
        })),
      ),
    })),
  );
};
